import React, { createContext, useState, useEffect } from "react";
import Cookies from 'js-cookie';
import { MainLoading } from '../components/mains/MainLoading'
const context = createContext(null);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [waitlisted, setWaitlisted] = useState(false);
  const [is_user, setIsUser] = useState(false);
  const [banned, setBanned] = useState(false);

  //UI
  const [showHowItWorks, setshowHowItWorks] = useState(false);
  const [showEnterWaitlist, setEnterWaitlist] = useState(false);
  const [showExitWaitlist, setExitWaitlist] = useState(false);

  useEffect(() => {
      setLoading(true)
      var user_data_cookie = Cookies.get('user_data')
      if (user_data_cookie){
        var user_data = JSON.parse(atob(user_data_cookie));
        setUser(user_data)
        fetch(`${process.env.REACT_APP_API_URL}/waitlist/`, {
          headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
          credentials: 'include',
          method: 'GET',
        })
        .then(function (res) {
          if(res.status === 200){
            res.json().then(function(data){
              if(data.code === "EXISTS") {
                setWaitlisted(true)
              }
              else if(data.code === "ALREADY_USER") {
                setIsUser(true)
              }
              else if(data.code === "DOES_NOT_QUALIFY") {
                setBanned(true)
              }
              setLoading(false)
            })
          }
          else if(res.status === 403){
            res.json().then(function(data){
              if(data.message === "Banned"){
                setBanned(true)
              }
            })
            setLoading(false)
          }
          else{
            console.log('Internal Server Error');
            setLoading(false)
          }
        })     
        .catch(err => {
            console.log(err);
            setLoading(false)
        });    
      } else {
        setLoading(false) 
      }
  }, []);

  return (
    <div className="parent">
      {
        !loading &&
        <context.Provider value={{user, loading, waitlisted, setWaitlisted, is_user, setIsUser, banned, setBanned, showHowItWorks, setshowHowItWorks, showEnterWaitlist, setEnterWaitlist, showExitWaitlist, setExitWaitlist}}>
            {children}
        </context.Provider>
      }
      {
        loading &&
        <div className="parent">
          <MainLoading/>
        </div>
      }
    </div>
  );
};

UserProvider.context = context;

export default UserProvider;
